import { Component } from '@angular/core';

@Component({
  selector: 'app-main-outlet',
  templateUrl: './main-outlet.component.html',
  styleUrls: ['./main-outlet.component.scss'],
})
export class MainOutletComponent {}
